module.exports = __webpack_public_path__ + "img/75638.0294c67e.svg";